import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import Button from "components/CustomButtons/Button.jsx"

import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx"
import { showMailingPopUp } from "../../../assets/helpers/mailchimp.js"

class WorkSection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: "",
      email: "",
      message: "",
    }
  }

  handleJoin() {
    // loadMonkeyChimp();
    showMailingPopUp()

    // .start({"baseUrl":"mc.us19.list-manage.com","uuid":"cc9c10880bcc359ad0ee8f11f","lid":"a8f2e34f7e","uniqueMethods":true});
  }
  render() {
    const { classes } = this.props
    return (
      <div
        className={classes.section}
        style={{ backgroundColor: "#005b9a", backgroundPosition: "-10% 0%" }}
      >
        <GridContainer justify="center">
          <GridItem
            cs={12}
            sm={12}
            md={8}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <h2 className={classes.title}>Find Out When We Launch</h2>
            <Button
              color="success"
              size="lg"
              rel="noopener noreferrer"
              onClick={() => {
                this.handleJoin()
              }}
            >
              <b>Become an Early Adopter</b>
            </Button>

            <h4 className={classes.description}>
              Or email us at contact@privasee.co.uk with the subject "Early
              Adopter".
            </h4>
          </GridItem>
        </GridContainer>

        <GridContainer justify="center" style={{marginTop: '6%'}}>
          <GridItem cs={12} sm={12} md={8}>
            <h2 className={classes.title}>Work With Us</h2>
            <h4 className={classes.description}>
              By allowing your users to login/signup to your company with their
              Privasee account you will be able to manage your users’ data
              requests through a single portal and ensure that the information
              that you are using is GDPR compliant. With Privasee you will help
              your users manage their data, keeping their information safe. To
              use privasee email <b>contact@privasee.co.uk</b>
            </h4>

            {/*
              <form
                action="mailto:contact@privasee.co.uk?subject=New Company Enquiry"
                data-rel="external"
                method="get"
                enctype="text/plain"
              >
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Your Name"
                    id="name"
                    name="name"
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Your Email"
                    id="email"
                    name="email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
                <CustomInput
                  labelText="Your Message"
                  id="message"
                  name="message"
                  formControlProps={{
                    fullWidth: true,
                    className: classes.textArea,
                  }}
                  inputProps={{
                    multiline: true,
                    rows: 5,
                  }}
                />
                <GridContainer justify="center">
                  <GridItem
                    xs={10}
                    sm={12}
                    md={10}
                    className={classes.textCenter}
                  >
                    <Button color="primary" type="submit">
                      Send Message
                    </Button>
                  </GridItem>
              </GridContainer>
              </GridContainer>
              </form>
            */}
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

export default withStyles(workStyle)(WorkSection)
